module.exports = __webpack_public_path__ + "img/banner.6ea0c134.jpg";